import React, { useState, useEffect, useRef } from "react";

import api from "../../../service/api";

import LoadingDot from "../../../components/loadings/LoadingDot";
import { dataZero } from "../../../utils/dataProcessing";

import { useHistory } from "react-router-dom";

import { Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";

import {
  Container,
  Filter,
  FilterCheck,
  ContainerList,
  TableContainer,
  FooterContainer,
  Form,
  FilterSelects,
  LoadingPanel,
} from "../styles";

import { FiSearch } from "react-icons/fi";
import { IoMdCloseCircle } from "react-icons/io";
import { MdAdd } from "react-icons/md";
// import Loading from "../../../components/Loading";
import useOutsideAlerter from "../../../hook/outsideAlerter";
import { IPermissionUser } from "../../../@types";

interface IPermission {
  id: number;
  name: string;
  created_at: Date;
}

interface IHeaderProps {
  admin: boolean;
  permission: IPermissionUser;
}

interface IFilter {
  cod?: string;
  name?: string;
}

interface IRequestPagination {
  limitRequest?: number;
  pageRequest?: number;
}

interface IPagination {
  total: number;
  limit: number;
  page: number;
  pages: number;
}

interface IResponseAPI {
  contents: IPermission[];
  total: number;
  limit: number;
  page: number;
  pages: number;
}

const PanelPermissions: React.FC<IHeaderProps> = ({ admin, permission }) => {
  const history = useHistory();
  const outSideRef = useRef(null);

  const [filterView, setFilterView] = useState(false);
  const [filters, setFilters] = useState<IFilter>({});

  const [contents, setContents] = useState<IPermission[]>([]);

  const [loading, setLoading] = useState({
    panel: true,
  });

  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [requestPagination, setRequestPagination] =
    useState<IRequestPagination>({ limitRequest: 15 } as IRequestPagination);

  useEffect(() => {
    (async () => {
      try {
        setLoading({ ...loading, panel: true });
        if (admin) {
          const responseAdmin = await api.get<IResponseAPI>("/permission", {
            params: { ...filters, ...requestPagination },
          });

          const { contents, limit, page, pages, total } = responseAdmin.data;

          setContents(contents);
          setPagination({ limit, page, pages, total });
          setLoading({ ...loading, panel: false });
        }
      } catch (error) {}
    })();
    // eslint-disable-next-line
  }, [filters, requestPagination]);

  function hadleFilter(filter: IFilter) {
    setFilters(filter);
    setRequestPagination({
      ...requestPagination,
      pageRequest: 0,
    });
    setFilterView(false);
  }

  function hadleNextPage() {
    setRequestPagination({
      ...requestPagination,
      pageRequest: pagination.page + 1,
    });
  }

  function hadlePreviousPage() {
    setRequestPagination({
      ...requestPagination,
      pageRequest: pagination.page - 1,
    });
  }

  function hadleToNewUser() {
    history.push("/admin/criar/permissao");
  }

  useOutsideAlerter(outSideRef, () => {
    if (filterView) setFilterView(false);
  });

  return (
    <Container>
      <header>
        <h2>Lista de Permissão</h2>
      </header>

      <Filter>
        <button
          onClick={() => {
            setFilterView(!filterView);
          }}
          type="button"
        >
          <FiSearch />
        </button>
        <input
          onClick={() => {
            setFilterView(!filterView);
          }}
          type="text"
          name="filter"
          id="filter"
          readOnly={true}
        />
        <FilterSelects>
          <ul>
            {filters.cod && (
              <li>
                <span>CÓDIGO: {filters.cod}</span>
                <IoMdCloseCircle
                  onClick={() => setFilters({ ...filters, cod: undefined })}
                />
              </li>
            )}

            {filters.name && (
              <li>
                <span>NOME: {filters.name}</span>
                <IoMdCloseCircle
                  onClick={() => setFilters({ ...filters, name: undefined })}
                />
              </li>
            )}
          </ul>
        </FilterSelects>

        {filterView && (
          <FilterCheck ref={outSideRef}>
            <header>
              <button
                onClick={() => {
                  setFilterView(false);
                }}
              >
                Fechar
              </button>
            </header>
            <main>
              <Formik
                initialValues={{
                  cod: filters.cod,
                  name: filters.name,
                }}
                validationSchema={Yup.object({})}
                onSubmit={(data) => {
                  hadleFilter({
                    ...data,
                  });
                }}
              >
                {(formik) => (
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="field-group">
                      <div className="field">
                        <label htmlFor="cod">CÓDIGO</label>
                        <input id="cod" {...formik.getFieldProps("cod")} />
                      </div>

                      <div className="field">
                        <label htmlFor="name">NOME</label>
                        <input id="name" {...formik.getFieldProps("name")} />
                      </div>
                    </div>

                    <footer>
                      <button
                        className="clearFilter"
                        type="button"
                        onClick={() => {
                          setFilterView(false);
                          setFilters({});
                        }}
                      >
                        LIMPAR FILTRO
                      </button>
                      <button type="submit">BUSCAR</button>
                    </footer>
                  </Form>
                )}
              </Formik>
            </main>
          </FilterCheck>
        )}
      </Filter>

      <ContainerList>
        <div className="headerTable">
          <h3>Permissões</h3>

          {permission && permission.permission && permission.permission > 2 && (
            <button onClick={hadleToNewUser} type="button">
              <MdAdd size={22} /> <span> NOVO PERFIL DE PERMISSÃO </span>
            </button>
          )}
        </div>

        <TableContainer>
          {!loading.panel ? (
            <table>
              <thead>
                <tr>
                  <th>CÓDIGO</th>
                  <th>NOME</th>
                  <th>DATA CRIAÇÃO</th>
                </tr>
              </thead>

              <tbody>
                {contents.map((element) => (
                  <tr
                    key={element.id}
                    onClick={() => {
                      history.push(`/admin/permissao/${element.id}`);
                    }}
                  >
                    <td>{element.id}</td>
                    <td>{element.name}</td>
                    <td>{moment(element.created_at).format("DD/MM/YYYY")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <LoadingPanel>
              <LoadingDot />
            </LoadingPanel>
          )}
        </TableContainer>
        <FooterContainer>
          <span>
            Mostrado{" "}
            {dataZero(
              Number(contents.length + pagination.limit * pagination.page)
            )}{" "}
            de {dataZero(Number(pagination.total))} resultados
          </span>

          <div>
            <button
              className={pagination.page < 1 ? "buttonNull" : ""}
              onClick={pagination.page < 1 ? () => {} : hadlePreviousPage}
              type="button"
            >
              ANTERIOR
            </button>
            <p style={{ marginRight: 8 }}>
              {dataZero(Number(pagination.page + 1))}
            </p>
            <button
              className={
                pagination.page >= pagination.pages ? "buttonNull" : ""
              }
              type="button"
              onClick={
                Number(pagination.page) >= Number(pagination.pages)
                  ? () => {}
                  : hadleNextPage
              }
            >
              PROXIMO
            </button>
          </div>
        </FooterContainer>
      </ContainerList>
    </Container>
  );
};

export default PanelPermissions;
